import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../features/auth/authSlice';
import sensorReducer from '../features/sensors/sensorSlice';
import ruleReducer from '../features/rules/ruleSlice';
import outputStateReducer from '../features/outputState/outputStateSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    deviceData: sensorReducer,
    rulesData: ruleReducer,
    outputStateData: outputStateReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
